<div class="vi-textarea">
  <vi-ui-label *ngIf="label"
    [for]="name"
    [disabled]="disabled"
    [value]="label"></vi-ui-label>
  <div *ngIf="!error && (description || counter)"
    class="textarea-description">
    <span *ngIf="description"
      [attr.id]="descriptionId">{{description}}</span>
    <span *ngIf="counter"
      [attr.id]="counterId">{{counter}}</span>
  </div>
  <!-- Named content projection slot for inline helper UI (e.g., alert-message bars).
       Consumers project elements with a `textareaSlot` attribute between the description and the textarea. -->
  <ng-content select="[textareaSlot]"></ng-content>
  <textarea [attr.name]="name"
    [attr.id]="name"
    [ngClass]="{error: error}"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.aria-describedby]="describedByIds"
    [attr.aria-invalid]="error ? 'true' : null"
    [attr.aria-errormessage]="error ? errorMessageId : null"
    [(ngModel)]="value"
    [maxlength]="maxLength"
    [ngStyle]="{height: height || DEFAULT_HEIGHT}"
    (input)="inputChanged.emit($event.target.value)"
    (focusout)="onFocusedOut($event.target.value)"></textarea>
  <span class="error-message"
    *ngIf="error"
    [attr.id]="errorMessageId"
    role="alert"
    aria-live="assertive">
    {{ errorMessage }}
  </span>
</div>